import {
  MarkdownTextPrimitive,
  unstable_memoizeMarkdownComponents as memoizeMarkdownComponents,
  useIsMarkdownCodeBlock,
} from '@assistant-ui/react-markdown';
import Markdown from '@wandb/weave/common/components/Markdown';
import {MarkdownContainer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/ChatView/MarkdownContainer';
import React, {memo} from 'react';
import remarkGfm from 'remark-gfm';

import {CodeSnippet} from '../CodeSnippet';

// keeping this for userMessage, but it will eventually be replaced by AUI's
// DirectiveText when we switch the composer/mention system over.
export const WBAgentMarkdown = memo(({content}: {content: string}) => (
  <MarkdownContainer>
    <Markdown content={content} shouldEjectFromTailwind={false} />
  </MarkdownContainer>
));
WBAgentMarkdown.displayName = 'WBAgentMarkdown';

const Code = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLElement>) => {
  const isCodeBlock = useIsMarkdownCodeBlock();
  if (isCodeBlock) {
    const language = className?.replace(/^language-/, '') ?? 'python';
    return (
      <div className="pb-16">
        <CodeSnippet
          codeSnippet={String(children).replace(/\n$/, '')}
          codeLanguage={language}
        />
      </div>
    );
  }
  return (
    <code className={className} {...props}>
      {children}
    </code>
  );
};

const assistantMarkdownComponents = memoizeMarkdownComponents({
  pre: ({children}) => <>{children}</>,
  code: Code,
});

export const MarkdownText = memo(() => (
  <MarkdownContainer>
    <MarkdownTextPrimitive
      remarkPlugins={[remarkGfm]}
      components={assistantMarkdownComponents}
    />
  </MarkdownContainer>
));

MarkdownText.displayName = 'MarkdownText';
